import { FormField, Select, Input } from '@shipengine/formik-giger';
import { CustomsReasonToExport } from '@packlink/packlink-sdk';
import { FastField } from 'formik';
import { getComposedFieldName } from '@packlink/utils';
import { useEffect } from 'react';
import { Option } from '@shipengine/giger';
import { ProviderName } from '@packlink/metrics';
import { useTranslation } from '@packlink/translation-provider';
import { TaxForm } from './TaxForm.js';
import { translateSelectOptions } from '../../../utils/select.js';
import { useCustomsFormContext, useCustomsFormData } from '../../../CustomsFormData.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { useSendMetrics } from '../../../hooks/useSendMetrics.js';
import { AmplitudeEvents, AmplitudeProperties } from '../../../data/amplitude.js';
import { reasonsToExportOptions } from '../../../data/ReasonsToExport.js';
import { getNewCustomsInvoiceItem } from '../../../data/dataTransformation.js';
import { CustomsSection, CustomsSectionVariant } from '../../Partials/CustomsSection.js';

function SenderInformationForm() {
  var _values$sender$vatSta, _values$reasonsToExpo, _values$inventoryOfCo;
  const {
    fieldNamePrefix,
    defaultCustomsCategory
  } = useCustomsFormContext();
  const {
    values,
    setFieldValue
  } = useCustomsFormData();
  const {
    t
  } = useTranslation();
  const sendMetrics = useSendMetrics();
  const showReasonsToExport = (_values$sender$vatSta = values.sender.vatStatus) === null || _values$sender$vatSta === void 0 ? void 0 : _values$sender$vatSta.value;
  const selectedReasonToExport = (_values$reasonsToExpo = values.reasonsToExport) === null || _values$reasonsToExpo === void 0 ? void 0 : _values$reasonsToExpo.value;
  const showInvoiceNumber = showReasonsToExport && selectedReasonToExport === CustomsReasonToExport.PURCHASE_OR_SALE;
  const translatedReasonsToExportOptions = translateSelectOptions(reasonsToExportOptions, t);
  useEffect(() => {
    if (!selectedReasonToExport) {
      return;
    }
    sendMetrics({
      providerName: ProviderName.AMPLITUDE,
      eventName: AmplitudeEvents.SELECT_CUSTOMS_REASONS_TO_EXPORT,
      payload: {
        [AmplitudeProperties.REASON_TO_EXPORT]: selectedReasonToExport
      }
    });
  }, [sendMetrics, selectedReasonToExport]);
  useEffect(() => {
    const isInventoryEmpty = values.inventoryOfContents.length === 0;
    const inventoryOfContentsFieldName = getComposedFieldName(fieldNamePrefix, 'inventoryOfContents');
    if (selectedReasonToExport === CustomsReasonToExport.DOCUMENTS) {
      setFieldValue(inventoryOfContentsFieldName, [], true);
    } else if (isInventoryEmpty) {
      setFieldValue(inventoryOfContentsFieldName, [getNewCustomsInvoiceItem({
        defaultCustomsCategory,
        t
      })]);
    }
  }, [selectedReasonToExport, setFieldValue, defaultCustomsCategory, t, fieldNamePrefix, (_values$inventoryOfCo = values.inventoryOfContents) === null || _values$inventoryOfCo === void 0 ? void 0 : _values$inventoryOfCo.length]);
  return jsxs(CustomsSection, {
    title: t('customs-form.tax-info.sender-title'),
    variant: CustomsSectionVariant.SUBSECTION,
    children: [jsx(TaxForm, {
      type: "sender",
      "data-id": "customs-form-sender-tax-form"
    }), showReasonsToExport && jsx(FormField, {
      name: getComposedFieldName(fieldNamePrefix, 'reasonsToExport'),
      children: jsx(FastField, {
        component: Select,
        label: t('customs-form.tax-info.export-reason-label'),
        children: translatedReasonsToExportOptions.map(option => jsx(Option, {
          value: option.value,
          children: option.label
        }, option.value))
      })
    }), showInvoiceNumber && jsx(FormField, {
      name: getComposedFieldName(fieldNamePrefix, 'invoiceNumber'),
      children: jsx(FastField, {
        component: Input,
        type: "text",
        label: t('customs-form.tax-info.invoice-number-label')
      })
    })]
  });
}

export { SenderInformationForm };
//# sourceMappingURL=SenderInformationForm.js.map
